import { loading, success, error } from 'State/actions';
import { FileDownloadTypes } from 'Common/Constants/Enumeration/CommonEnum';
import * as types from './types';

export const getExtendedBenefitsReport = model => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.EXTENDED_BENEFITS_REPORT_FETCHING, true));
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Reports/ExtendedBenefitsReport',
        model
      );
      dispatch(success(types.EXTENDED_BENEFITS_GET_REPORT, response.data.Data));
    } catch (exception) {
      dispatch(error(types.EXTENDED_BENEFITS_FETCH_ERROR, exception.response));
    } finally {
      dispatch(loading(types.EXTENDED_BENEFITS_REPORT_FETCHING, false));
    }
  };
};

export const getExtendedBenefitsExcelReport = model => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.EXTENDED_BENEFITS_REPORT_FETCHING, true));
      const response = await MPWWebApi.postDownloadFile(
        'Reports/ExtendedBenefitsReport',
        'Extended Benefits Report',
        model,
        FileDownloadTypes.ExcelOpenXML
      );
      dispatch(success(types.EXTENDED_BENEFITS_GET_EXCEL_REPORT, response));
    } catch (exception) {
      dispatch(error(types.EXTENDED_BENEFITS_FETCH_ERROR, exception.response));
    } finally {
      dispatch(loading(types.EXTENDED_BENEFITS_REPORT_FETCHING, false));
    }
  };
};

export const clearReport = () => {
  return dispatch => {
    dispatch({ type: types.EXTENDED_BENEFITS_CLEAR_REPORT });
  };
};



// WEBPACK FOOTER //
// ./src/pages/extendedbenefits/state/report/actions.js